const getters = {
  token: state => state.user.token,
  user: state => state.user.user,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  theme: state => state.settings.theme,
}
export default getters
